import { authHeaderNoToken, handleResponse } from "../helper/auth-header";

export default class IsopureService {
  ControllerName = "Isopure";

  async CheckIsopureQR(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CheckIsopureQR`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
